var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lte-navibar',{on:{"viewProjectList":_vm.viewProjectList}}),_vm._v(" "),_c('lte-sidebar',{attrs:{"slideMenuItems":_vm.slideMenuItems}}),_vm._v(" "),_c('lte-contentwrap',{ref:"contentwrap"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d9aba36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout/DefaultLayout.vue
// module id = null
// module chunks = 